module.exports = __webpack_public_path__ + "static/media/Poster_Illustration.dcaa6877.jpg";